import React from 'react';
import './UsaFooter.css';

const UsaFooter = () => {
  return (
    <footer className="usa-footer">
      <div className="usa-footer__container">
        {/* Left Side: Logo */}
        <div className="usa-footer__logo-box">
          <a href="/usa/" aria-label="Al Quran Lesson">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/FooterLogo.png`}
              alt="Al Quran Lesson"
              className="usa-footer__logo-img"
            />
          </a>
        </div>

        {/* Right Side: Privacy Policy Link */}
        <div className="usa-footer__right">
          <a href="/privacy-policy/" className="usa-footer__link">
            PRIVACY POLICY
          </a>
        </div>
      </div>
    </footer>
  );
};

export default UsaFooter;
